<template>
  <div class="carousel-container">
    <Carousel :itemsToShow="3.95" :wrapAround="true">
      <Slide v-for="image in profileOrder" :key="image.id">
        <div class="carousel__item">
        <img :src="image.url" alt="Placeholder image">
        <div class="menu-card-content">
              <h3 class="mb-5">{{image.firstName}} {{image.lastName}}</h3>
              <button @click="menuOpenHandler(image.anchor)" class="button is-large show-more-btn">Read more</button>
            </div>
        </div>      
      </Slide>
      <template #addons>
        <navigation />
        <pagination />
      </template>
    </Carousel>
  </div>
</template>


<script>

import { computed, defineComponent, ref } from 'vue'
import { Carousel, Pagination, Slide, Navigation } from 'vue3-carousel';
import '../../node_modules/vue3-carousel/dist/carousel.css';

export default defineComponent({
  name: 'Autoplay',
  props: ["images"],
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation
  },
  setup(props) {  

    const profileOrder = computed(() => {
      return props.images.sort((a, b) => a.lastName.localeCompare(b.lastName))
    })

      const menuOpenHandler = (anchor) => {
        console.log(anchor)
        document.getElementById(anchor).scrollIntoView({behavior: "smooth"});
      }

    return { profileOrder, menuOpenHandler }
  }
});


</script>

<style scoped>
.carousel__slide > .carousel__item {
  transform: scale(1);
  opacity: 1;
  transition: all 10s ease; 
}
.carousel__slide--visible > .carousel__item {
  opacity: 1;
  transform: rotateY(0);
}
/* .carousel__slide--next > .carousel__item {
  transform: scale(0.9) translate(-10px);
}
.carousel__slide--prev > .carousel__item {
  transform: scale(0.9) translate(10px);
} */
/* .carousel__slide--active > .carousel__item {
  transform: scale(1.1);
  z-index: 999;
} */

.card-image .image {
  max-height: 50rem;
}

.card {
  max-width: 38rem;
}



.carousel__item {
  margin: 0 3rem;
}





/* .carousel__item img {
width: auto;
height: 30rem;
display: block;
z-index: 999;
} */
</style>